// ═══════════════════════════════════════════════════════════════
//  SYLEVA — Calculateur Charpente, mode commande Shopify
//  Fichier : assets/calculateur-charpente-commande.js
//
//  Les prix ne sont pas calculés ici. Ils proviennent des variantes
//  Shopify exposées par le Liquid, puis le panier Shopify fait foi.
// ═══════════════════════════════════════════════════════════════

// ── Règles techniques, sans tarif ─────────────────────────────
var SC_SECHAGE = {
  standard: {
    label: 'Ressuyé',
    delaiSemaines: 0
  },
  naturel18: {
    label: 'Naturel H ≤ 18 %',
    delaiSemaines: 15
  },
  sechoir18: {
    label: 'Séchoir H ≤ 18 %',
    delaiSemaines: 0
  }
};
var SC_SECHAGE_DEFAUT = 'standard';
var SC_TVA_RATE = 0.20;
var scPriceMode = 'TTC';
var SC_CUSTOM_ORDER_WARNING = 'Les produits commandés via cet outil sont personnalisés et fabriqués à la commande. Ils ne peuvent être ni repris ni échangés, conformément aux conditions générales de vente.';

var SC_EP_MIN = 40, SC_EP_MAX = 300;
var SC_LO_MIN = 1, SC_LO_MAX = 6.5;
var SC_LO_STEP = 0.5;

var SC_RABOT_SURCOTE_EP = 10;
var SC_RABOT_SURCOTE_LA = 10;
var SC_RABOT_SURCOTES = [
  { ep: 45, la: 45,  surcoteEp: 7, surcoteLa: 8 },
  { ep: 45, la: 90,  surcoteEp: 7, surcoteLa: 8 },
  { ep: 45, la: 120, surcoteEp: 7, surcoteLa: 8 },
  { ep: 45, la: 145, surcoteEp: 7, surcoteLa: 8 },
  { ep: 45, la: 220, surcoteEp: 7, surcoteLa: 10 }
];
var SC_RABOT_EP_MIN = 45, SC_RABOT_EP_MAX = 140;
var SC_RABOT_LA_MIN = 45, SC_RABOT_LA_MAX = 260;
var SC_RABOT_LO_MIN = 2.5, SC_RABOT_LO_MAX = 6.5;
var SC_RABOT_SECHAGE_DEFAUT = 'naturel18';

// ── État ───────────────────────────────────────────────────────
var scRowsC = [], scRowsR = [], scRowsV = [], scId = 1;

// ── Helpers ───────────────────────────────────────────────────
function scClamp(v, mn, mx) { return Math.max(mn, Math.min(mx, v)); }
function scRoundLengthUp(v) {
  return Math.ceil((v / SC_LO_STEP) - 1e-9) * SC_LO_STEP;
}
function scGetRabotSurcote(ep, la) {
  for (var i = 0; i < SC_RABOT_SURCOTES.length; i++) {
    var exception = SC_RABOT_SURCOTES[i];
    if (exception.ep === ep && exception.la === la) {
      return { ep: exception.surcoteEp, la: exception.surcoteLa };
    }
  }
  return { ep: SC_RABOT_SURCOTE_EP, la: SC_RABOT_SURCOTE_LA };
}

// Les prix sont injectés directement par Liquid depuis les variantes Shopify.
// Le panier et le PDF utilisent ensuite les prix réellement ajoutés dans Shopify.
function scPriceCents(variant) {
  if (!variant || variant.priceAvailable === false) return null;
  var raw = variant.priceCents;
  if (raw == null) raw = variant.price;
  if (raw == null) raw = variant.price_cents;
  if (raw == null) return null;
  if (typeof raw === 'string') raw = raw.trim().replace(/\s/g, '').replace(',', '.');
  var cents = Number(raw);
  return isFinite(cents) && cents >= 0 ? cents : null;
}
function scHasCustomPricing() {
  return !!(window.SC_CUSTOMER_PRICING && window.SC_CUSTOMER_PRICING.hasCustomTag);
}
function scPriceInfo(variant) {
  var publicCents = scPriceCents(variant);
  var customCents = variant && variant.customPriceCents != null ? Number(variant.customPriceCents) : publicCents;
  var pending = scHasCustomPricing() && variant && variant.customPriceCents == null && !variant.customPriceFailed;
  return {
    publicCents: publicCents,
    customCents: isFinite(customCents) ? customCents : null,
    pending: pending,
    discountRate: publicCents && customCents != null ? Math.max(0, 1 - (customCents / publicCents)) : 0
  };
}
function scPricePairHtml(publicValue, customValue, pending, whole, suffix) {
  var format = whole ? scFmtWhole : scFmt;
  var publicText = format(scDisplayedPrice(publicValue)) + suffix;
  if (!scHasCustomPricing()) return publicText;
  if (pending) return '<span class="sc-price-public">Public : ' + publicText + '</span><br><span class="sc-price-custom">Tarif personnalisé : en cours…</span>';
  var customText = format(scDisplayedPrice(customValue)) + suffix;
  if (Math.round(Number(publicValue) * 100) === Math.round(Number(customValue) * 100)) return publicText;
  return '<span class="sc-price-public">Public : ' + publicText + '</span><br><strong class="sc-price-custom">Votre tarif : ' + customText + '</strong>';
}

function scPdfPricePair(publicText, actualText) {
  if (!scHasCustomPricing() || !publicText || publicText === actualText) return actualText;
  return '<span class="small">Public : ' + scEscHtml(publicText) + '</span><br><strong>Votre tarif : ' + scEscHtml(actualText) + '</strong>';
}

var scCustomPriceProbeTimer = null;
var scCustomPriceProbeRunning = false;
var scCustomPriceProbeDirty = false;
var scCustomPriceProbeSequence = 0;

function scCustomPriceCandidates() {
  var candidates = {};
  function add(type, row, calc) {
    if (!calc || !calc.ok || !calc.variant || calc.variant.id == null) return;
    var key = String(calc.variant.id);
    if (calc.variant.customPriceCents != null || calc.variant.customPriceFailed) return;
    if (!candidates[key]) candidates[key] = { variant: calc.variant, quantity: Math.max(1, calc.quantity || 1), type: type };
  }
  scRowsC.forEach(function(row) { add('charpente', row, scCalcC(row)); });
  scRowsR.forEach(function(row) { add('rabote', row, scCalcR(row)); });
  scRowsV.forEach(function(row) { add('volige', row, scCalcV(row)); });
  return Object.keys(candidates).map(function(key) { return candidates[key]; });
}
function scScheduleCustomPriceProbe() {
  if (!scHasCustomPricing()) return;
  clearTimeout(scCustomPriceProbeTimer);
  scCustomPriceProbeTimer = setTimeout(scSyncCustomPrices, 250);
}
function scSyncCustomPrices() {
  if (!scHasCustomPricing()) return;
  if (scCustomPriceProbeRunning) { scCustomPriceProbeDirty = true; return; }
  var candidates = scCustomPriceCandidates();
  if (!candidates.length) return;
  scCustomPriceProbeRunning = true;
  var token = 'sc_custom_price_probe_' + Date.now() + '_' + (++scCustomPriceProbeSequence);
  var items = candidates.map(function(candidate) {
    return {
      id: Number(candidate.variant.id),
      quantity: candidate.quantity,
      properties: { '_sc_custom_price_probe': token }
    };
  });
  function cleanup() {
    return scGetCart().then(function(cart) {
      var probes = (cart.items || []).filter(function(item) {
        return item.properties && item.properties._sc_custom_price_probe === token;
      });
      return scRemoveCartItems(probes);
    }).catch(function(error) {
      console.warn('Nettoyage du test de tarif personnalisé impossible :', error);
    });
  }
  scPostCartItems(items)
    .then(function() { return scGetCart(); })
    .then(function(cart) {
      var probes = (cart.items || []).filter(function(item) {
        return item.properties && item.properties._sc_custom_price_probe === token;
      });
      candidates.forEach(function(candidate) {
        var line = probes.find(function(item) { return String(item.variant_id) === String(candidate.variant.id); });
        if (line) candidate.variant.customPriceCents = Number(line.final_price != null ? line.final_price : line.price);
      });
      return cleanup();
    })
    .catch(function(error) {
      candidates.forEach(function(candidate) { candidate.variant.customPriceFailed = true; });
      console.warn('Tarif personnalisé indisponible :', error);
      return cleanup();
    })
    .then(function() {
      scCustomPriceProbeRunning = false;
      scSetPriceMode(scPriceMode);
      if (scCustomPriceProbeDirty) {
        scCustomPriceProbeDirty = false;
        scScheduleCustomPriceProbe();
      }
    });
}


// ── Calculs techniques et prix Shopify ───────────────────────
function scCalcC(r) {
  var ep = scClamp(parseFloat(r.ep) || 0, 0, SC_EP_MAX);
  var la = scClamp(parseFloat(r.la) || 0, 0, SC_EP_MAX);
  var lo = scClamp(parseFloat(r.lo) || 0, 0, SC_LO_MAX);
  var qt = parseInt(r.qt, 10) || 0;
  var sec = (ep / 1000) * (la / 1000);
  var volPiece = sec * lo;
  var volTotal = volPiece * qt;
  var traite = !!r.traitement && r.essence === 'Sapin/Épicéa';
  var sechage = SC_SECHAGE[r.sechage] || SC_SECHAGE[SC_SECHAGE_DEFAUT];
  var variant = window.SC_SHOPIFY ? scFindCharpenteVariant(r) : null;
  // Les variantes charpente sont tarifées à la pièce.
  // La quantité Shopify correspond donc au nombre de pièces demandé.
  var quantity = qt;
  var volTotalArrondi = Math.round((volTotal + 1e-9) * 1000) / 1000;
  var prices = scPriceInfo(variant);
  var hasPrice = prices.customCents != null;
  var publicUnitPrice = prices.publicCents != null ? prices.publicCents / 100 : null;
  var unitPrice = hasPrice ? prices.customCents / 100 : null;
  var publicPuM3 = publicUnitPrice != null && volPiece > 0 ? publicUnitPrice / volPiece : null;
  var puM3 = unitPrice != null && volPiece > 0 ? unitPrice / volPiece : null;
  var publicTotalHT = publicUnitPrice != null ? publicUnitPrice * quantity : null;
  var totalHT = unitPrice != null ? unitPrice * quantity : null;
  var geometryOk = ep >= SC_EP_MIN && la >= SC_EP_MIN && lo >= SC_LO_MIN && qt > 0;
  return {
    sec: sec, volPiece: volPiece, volTotal: volTotal, volTotalArrondi: volTotalArrondi, quantity: quantity,
    unitPrice: unitPrice, puM3: puM3, publicPuM3: publicPuM3,
    publicTotalHT: publicTotalHT, totalHT: totalHT, discountRate: prices.discountRate,
    customPricePending: prices.pending, publicPriceCents: prices.publicCents,
    traite: traite, sechage: sechage, variant: variant,
    priceAvailable: hasPrice,
    ok: geometryOk && !!variant
  };
}

function scCalcR(r) {
  var ep = parseInt(r.ep, 10) || 0;
  var la = parseInt(r.la, 10) || 0;
  var lo = scClamp(parseFloat(r.lo) || 0, 0, SC_RABOT_LO_MAX);
  var qt = parseInt(r.qt, 10) || 0;
  var surcote = scGetRabotSurcote(ep, la);
  var epBrut = ep + surcote.ep;
  var laBrut = la + surcote.la;
  var secBrut = (epBrut / 1000) * (laBrut / 1000);
  var secFinal = (ep / 1000) * (la / 1000);
  var volumePieceFinal = secFinal * lo;
  var volBrut = secBrut * lo * qt;
  var volFinal = volumePieceFinal * qt;
  var traite = !!r.traitement && r.essence === 'Sapin/Épicéa';
  var sechage = r.sechage === 'sechoir18' ? SC_SECHAGE.sechoir18 : SC_SECHAGE.naturel18;
  var variant = window.SC_SHOPIFY ? scFindRabotVariant(r) : null;
  var prices = scPriceInfo(variant);
  var hasPrice = prices.customCents != null;
  var publicUnitPrice = prices.publicCents != null ? prices.publicCents / 100 : null;
  var unitPrice = hasPrice ? prices.customCents / 100 : null;
  var publicTotalHT = publicUnitPrice != null ? publicUnitPrice * qt : null;
  var totalHT = unitPrice != null ? unitPrice * qt : null;
  var publicPuM3 = publicUnitPrice != null && volumePieceFinal > 0 ? publicUnitPrice / volumePieceFinal : null;
  var puM3 = unitPrice != null && volumePieceFinal > 0 ? unitPrice / volumePieceFinal : null;
  var geometryOk = ep >= SC_RABOT_EP_MIN && ep <= SC_RABOT_EP_MAX
    && la >= SC_RABOT_LA_MIN && la <= SC_RABOT_LA_MAX
    && lo >= SC_RABOT_LO_MIN && lo <= SC_RABOT_LO_MAX && qt > 0;
  return {
    ep: ep, la: la, lo: lo, epBrut: epBrut, laBrut: laBrut,
    surcoteEp: surcote.ep, surcoteLa: surcote.la,
    secBrut: secBrut, secFinal: secFinal,
    volumePieceFinal: volumePieceFinal, volBrut: volBrut, volFinal: volFinal,
    traite: traite, sechage: sechage, variant: variant,
    unitPrice: unitPrice, puM3: puM3, publicPuM3: publicPuM3,
    publicTotalHT: publicTotalHT, totalHT: totalHT, discountRate: prices.discountRate,
    customPricePending: prices.pending, publicPriceCents: prices.publicCents,
    priceAvailable: hasPrice, ok: geometryOk && !!variant
  };
}

function scCalcV(r) {
  var ep = parseInt(r.ep, 10) || 15;
  var largeurSaisie = parseFloat(r.la) || 0;
  var la = largeurSaisie > 0 ? Math.ceil(largeurSaisie - 1e-9) : 0;
  var lo = parseFloat(r.lo) || 0;
  var m2 = la * lo;
  var miBois = !!r.miBois && ep === 18;
  var variant = window.SC_SHOPIFY ? scFindVoligeVariant(r) : null;
  var quantity = la;
  var prices = scPriceInfo(variant);
  var hasPrice = prices.customCents != null;
  var publicUnitPrice = prices.publicCents != null ? prices.publicCents / 100 : null;
  var unitPrice = hasPrice ? prices.customCents / 100 : null;
  var publicTotalHT = publicUnitPrice != null ? publicUnitPrice * quantity : null;
  var totalHT = unitPrice != null ? unitPrice * quantity : null;
  var publicPuM2 = publicUnitPrice != null && lo > 0 ? publicUnitPrice / lo : null;
  var puM2 = unitPrice != null && lo > 0 ? unitPrice / lo : null;
  var geometryOk = (ep === 15 || ep === 18) && la > 0 && lo > 0;
  return {
    ep: ep, la: la, m2: m2, quantity: quantity,
    volumeFinal: (ep / 1000) * m2,
    unitPrice: unitPrice, puM2: puM2, publicPuM2: publicPuM2,
    publicTotalHT: publicTotalHT, totalHT: totalHT, discountRate: prices.discountRate,
    customPricePending: prices.pending, publicPriceCents: prices.publicCents, miBois: miBois,
    variant: variant, priceAvailable: hasPrice, ok: geometryOk && !!variant
  };
}

function scTotaux() {
  var countC = 0, countR = 0, countV = 0;
  var totalC = 0, totalR = 0, totalV = 0;
  var missingMain = false, missingR = false, missingV = false;

  scRowsC.forEach(function(r) {
    var c = scCalcC(r);
    if (!c.ok) return;
    countC++;
    if (c.priceAvailable) totalC += c.totalHT;
    else missingMain = true;
  });
  scRowsR.forEach(function(r) {
    var c = scCalcR(r);
    if (!c.ok) return;
    countR++;
    if (c.priceAvailable) totalR += c.totalHT;
    else missingR = true;
  });
  scRowsV.forEach(function(r) {
    var c = scCalcV(r);
    if (!c.ok) return;
    countV++;
    if (c.priceAvailable) totalV += c.totalHT;
    else missingV = true;
  });

  var mainCount = countC + countV;
  var orderableCount = mainCount + countR;
  return {
    countC: countC, countR: countR, countV: countV,
    totalC: totalC, totalR: totalR, totalV: totalV,
    totalMain: totalC + totalV, total: totalC + totalR + totalV,
    mainPriceComplete: mainCount > 0 && !missingMain,
    rabotePriceComplete: countR > 0 && !missingR,
    priceComplete: orderableCount > 0 && !missingMain && !missingR && !missingV,
    hasOrderableItems: orderableCount > 0
  };
}

function scDate() { return new Date().toLocaleDateString('fr-FR'); }
function scToggleAccordion(button) {
  var card = button.parentElement;
  if (!card) return;
  var collapsed = card.classList.toggle('is-collapsed');
  var expanded = !collapsed;
  button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  var icon = button.querySelector('.sc-accordion-icon');
  if (icon) icon.textContent = expanded ? '−' : '+';
}
function scSechageLabel(s, details) {
  var label = s.label;
  if (details && s.delaiSemaines > 0) label += ' (≈ ' + s.delaiSemaines + ' sem.)';
  return label;
}

function scFmt(n) {
  return Number(n).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';
}

function scFmtWhole(n) {
  return Math.round(Number(n) || 0).toLocaleString('fr-FR') + ' €';
}

function scDisplayedPrice(euros) {
  var value = Number(euros) || 0;
  return scPriceMode === 'HT' ? value / (1 + SC_TVA_RATE) : value;
}
function scPriceModeLabel() {
  return scPriceMode === 'HT' ? 'HT' : 'TTC';
}
function scSechagePdfLabel(key) {
  if (key === 'standard') return 'Ressuyé';
  if (key === 'naturel18') return 'Naturel H ≤ 18 %';
  if (key === 'sechoir18') return 'Séchoir H ≤ 18 %';
  return key || '';
}
function scSetPriceMode(mode) {
  scPriceMode = mode === 'HT' ? 'HT' : 'TTC';
  document.querySelectorAll('.sc-price-mode-label').forEach(function(el) {
    el.textContent = scPriceModeLabel();
  });
  var ttcButton = document.getElementById('sc-mode-ttc');
  var htButton = document.getElementById('sc-mode-ht');
  if (ttcButton) {
    ttcButton.classList.toggle('is-active', scPriceMode === 'TTC');
    ttcButton.setAttribute('aria-pressed', scPriceMode === 'TTC' ? 'true' : 'false');
  }
  if (htButton) {
    htButton.classList.toggle('is-active', scPriceMode === 'HT');
    htButton.setAttribute('aria-pressed', scPriceMode === 'HT' ? 'true' : 'false');
  }
  scRowsC.forEach(function(r) { scUpdateRowC(r.id); });
  scRowsR.forEach(function(r) { scUpdateRowR(r.id); });
  scRowsV.forEach(function(r) { scUpdateRowV(r.id); });
  scMajTotaux();
}
function scSetEmptyHint(id, visible) {
  var el = document.getElementById(id);
  if (el) el.style.display = visible ? '' : 'none';
}
function scFocusFirstField(row) {
  if (!row) return;
  var field = row.querySelector('input, select, textarea');
  if (field) setTimeout(function() { field.focus(); }, 0);
}

// ── Création ligne charpente (une seule fois) ─────────────────
function scAddRowC(r, focus) {
  var tbody = document.getElementById('sc-tbody-c');
  var tr = document.createElement('tr');
  tr.id = 'sc-row-c-' + r.id;
  tr.innerHTML =
    '<td><select id="sc-c-ep-' + r.id + '" onchange="scUpdC(' + r.id + ',\'ep\',this.value)" style="min-width:78px">'
    + scCharpenteThicknessOptions(r.ep) + '</select></td>'
    + '<td><select id="sc-c-la-' + r.id + '" onchange="scUpdC(' + r.id + ',\'la\',this.value)" style="min-width:82px">'
    + scCharpenteWidthOptions(r) + '</select></td>'
    + '<td><select id="sc-c-lo-' + r.id + '" onchange="scUpdC(' + r.id + ',\'lo\',this.value)" style="min-width:75px">'
    + scCharpenteLengthOptions(r) + '</select></td>'
    + '<td><input id="sc-c-qt-' + r.id + '" type="number" min="1" value="' + (r.qt || 1) + '" style="width:52px"'
    + ' onchange="scUpdC(' + r.id + ',\'qt\',this.value)"></td>'
    + '<td><select onchange="scUpdCEss(' + r.id + ',this.value)">'
    + '<option value="Sapin/Épicéa"' + (r.essence === 'Sapin/Épicéa' ? ' selected' : '') + '>Sapin / Épicéa</option>'
    + '<option value="Douglas"' + (r.essence === 'Douglas' ? ' selected' : '') + '>Douglas</option>'
    + '</select></td>'
    + '<td id="sc-c-trait-' + r.id + '" style="text-align:center">'
    + '<input type="checkbox"' + (r.traitement ? ' checked' : '') + ' onchange="scUpdC(' + r.id + ',\'traitement\',this.checked)"></td>'
    + '<td><select onchange="scUpdC(' + r.id + ',\'sechage\',this.value)" style="min-width:128px">'
    + '<option value="standard"' + (r.sechage === 'standard' ? ' selected' : '') + '>Ressuyé</option>'
    + '<option value="naturel18"' + (r.sechage === 'naturel18' ? ' selected' : '') + '>Naturel H ≤ 18 % (≈ ' + SC_SECHAGE.naturel18.delaiSemaines + ' sem.)</option>'
    + '<option value="sechoir18"' + (r.sechage === 'sechoir18' ? ' selected' : '') + '>Séchoir H ≤ 18 %</option>'
    + '</select></td>'
    + '<td id="sc-c-vol-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-c-pml-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-c-tot-' + r.id + '" class="sc-num" style="font-weight:600">—</td>'
    + '<td><button type="button" class="sc-del" onclick="scDelC(' + r.id + ')">✕</button></td>';
  tbody.appendChild(tr);
  if (focus !== false) scFocusFirstField(tr);
}

// ── Mise à jour cellules résultat charpente ───────────────────
function scUpdateRowC(id) {
  var r = scRowsC.find(function(x) { return x.id === id; });
  if (!r) return;
  scRefreshCWidths(id);
  scRefreshCLengths(id);
  var c = scCalcC(r);

  var epEl = document.getElementById('sc-c-ep-' + id);
  if (epEl) epEl.value = String(r.ep);
  var laEl = document.getElementById('sc-c-la-' + id);
  if (laEl) laEl.value = String(r.la);
  var lengthEl = document.getElementById('sc-c-lo-' + id);
  if (lengthEl) lengthEl.value = String(r.lo);

  var traitEl = document.getElementById('sc-c-trait-' + id);
  if (traitEl) {
    var hasBox = !!traitEl.querySelector('input[type="checkbox"]');
    if (r.essence === 'Douglas' && hasBox) {
      traitEl.innerHTML = '<span class="sc-muted" style="font-size:11px">N/A</span>';
    } else if (r.essence !== 'Douglas' && !hasBox) {
      traitEl.innerHTML = '<input type="checkbox"' + (r.traitement ? ' checked' : '')
        + ' onchange="scUpdC(' + id + ',\'traitement\',this.checked)">';
    }
  }
  var volEl = document.getElementById('sc-c-vol-' + id);
  var pmlEl = document.getElementById('sc-c-pml-' + id);
  var totEl = document.getElementById('sc-c-tot-' + id);
  if (volEl) { volEl.textContent = c.ok ? c.volTotalArrondi.toFixed(3) + ' m³' : '—'; volEl.className = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (pmlEl) { pmlEl.innerHTML = c.priceAvailable ? scPricePairHtml(c.publicPuM3, c.puM3, c.customPricePending, true, ' / m³') : (c.ok ? 'Prix indisponible' : '—'); pmlEl.className = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (totEl) { totEl.innerHTML = c.priceAvailable ? scPricePairHtml(c.publicTotalHT, c.totalHT, c.customPricePending, false, '') : (c.ok ? 'Prix indisponible' : '—'); }
  scMajTotaux();
}

// ── Création ligne bois raboté ─────────────────────────────────
function scRabotThicknesses() {
  var values = [];
  scRabotSections().forEach(function(section) {
    if (values.indexOf(section.ep) === -1) values.push(section.ep);
  });
  return values.sort(function(a, b) { return a - b; });
}
function scRabotWidthsFor(r) {
  var variants = scRabotVariants().filter(function(v) {
    var d = scParseRabotSku(v.sku);
    return d && d.ep === parseInt(r.ep, 10);
  });
  var widths = [];
  variants.forEach(function(v) {
    var d = scParseRabotSku(v.sku);
    if (widths.indexOf(d.la) === -1) widths.push(d.la);
  });
  return widths.sort(function(a, b) { return a - b; });
}
function scRabotThicknessOptions(selected) {
  return scRabotThicknesses().map(function(value) {
    return '<option value="' + value + '"' + (String(value) === String(selected) ? ' selected' : '') + '>'
      + value + ' mm</option>';
  }).join('');
}
function scRabotWidthOptions(r) {
  return scRabotWidthsFor(r).map(function(value) {
    return '<option value="' + value + '"' + (String(value) === String(r.la) ? ' selected' : '') + '>'
      + value + ' mm</option>';
  }).join('');
}
function scRabotLengthOptions(r) {
  var lengths = scRabotLengthsFor(r);
  if (!lengths.length) return '<option value="">— m —</option>';
  return lengths.map(function(value) {
    var label = String(value).replace('.', ',');
    return '<option value="' + value + '"' + (String(value) === String(r.lo) ? ' selected' : '') + '>'
      + label + ' m</option>';
  }).join('');
}
function scRefreshRWidths(id) {
  var r = scRowsR.find(function(x) { return x.id === id; });
  var select = document.getElementById('sc-r-la-' + id);
  if (!r || !select) return;
  var widths = scRabotWidthsFor(r);
  if (!widths.length) {
    select.innerHTML = '<option value="">— mm —</option>';
    r.la = '';
    return;
  }
  var current = parseInt(r.la, 10);
  if (isNaN(current) || widths.indexOf(current) === -1) r.la = String(widths[0]);
  select.innerHTML = scRabotWidthOptions(r);
  select.value = String(r.la);
}
function scAddRowR(r, focus) {
  var tbody = document.getElementById('sc-tbody-r');
  var tr = document.createElement('tr');
  tr.id = 'sc-row-r-' + r.id;
  tr.innerHTML =
    '<td><select id="sc-r-ep-' + r.id + '" onchange="scUpdR(' + r.id + ',\'ep\',this.value)" style="min-width:80px">'
    + scRabotThicknessOptions(r.ep) + '</select></td>'
    + '<td><select id="sc-r-la-' + r.id + '" onchange="scUpdR(' + r.id + ',\'la\',this.value)" style="min-width:82px">'
    + scRabotWidthOptions(r) + '</select></td>'
    + '<td><select id="sc-r-lo-' + r.id + '" onchange="scUpdR(' + r.id + ',\'lo\',this.value)" style="min-width:75px">'
    + scRabotLengthOptions(r) + '</select></td>'
    + '<td><input type="number" min="1" value="' + (r.qt || 1) + '" style="width:52px"'
    + ' onchange="scUpdR(' + r.id + ',\'qt\',this.value)"></td>'
    + '<td><select onchange="scUpdREss(' + r.id + ',this.value)">'
    + '<option value="Sapin/Épicéa"' + (r.essence === 'Sapin/Épicéa' ? ' selected' : '') + '>Sapin / Épicéa</option>'
    + '<option value="Douglas"' + (r.essence === 'Douglas' ? ' selected' : '') + '>Douglas</option>'
    + '</select></td>'
    + '<td id="sc-r-trait-' + r.id + '" style="text-align:center">'
    + '<input type="checkbox"' + (r.traitement ? ' checked' : '')
    + ' onchange="scUpdR(' + r.id + ',\'traitement\',this.checked)"></td>'
    + '<td><select onchange="scUpdR(' + r.id + ',\'sechage\',this.value)" style="min-width:128px">'
    + '<option value="naturel18"' + (r.sechage === 'naturel18' ? ' selected' : '') + '>Naturel H ≤ 18 %</option>'
    + '<option value="sechoir18"' + (r.sechage === 'sechoir18' ? ' selected' : '') + '>Séchoir H ≤ 18 %</option>'
    + '</select></td>'
    + '<td id="sc-r-vol-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-r-pml-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-r-tot-' + r.id + '" class="sc-num" style="font-weight:600">—</td>'
    + '<td><button type="button" class="sc-del" onclick="scDelR(' + r.id + ')">✕</button></td>';
  tbody.appendChild(tr);
  if (focus !== false) scFocusFirstField(tr);
}

function scUpdateRowR(id) {
  var r = scRowsR.find(function(x) { return x.id === id; });
  if (!r) return;
  scRefreshRWidths(id);
  var c = scCalcR(r);
  var epEl = document.getElementById('sc-r-ep-' + id);
  if (epEl) epEl.value = String(r.ep);
  var laEl = document.getElementById('sc-r-la-' + id);
  if (laEl) laEl.value = String(r.la);
  var lengthEl = document.getElementById('sc-r-lo-' + id);
  if (lengthEl) lengthEl.value = String(r.lo);
  var traitEl = document.getElementById('sc-r-trait-' + id);
  if (traitEl) {
    var hasBox = !!traitEl.querySelector('input[type="checkbox"]');
    if (r.essence === 'Douglas' && hasBox) {
      traitEl.innerHTML = '<span class="sc-muted" style="font-size:11px">N/A</span>';
    } else if (r.essence !== 'Douglas' && !hasBox) {
      traitEl.innerHTML = '<input type="checkbox"' + (r.traitement ? ' checked' : '')
        + ' onchange="scUpdR(' + id + ',\'traitement\',this.checked)">';
    }
  }
  var volEl = document.getElementById('sc-r-vol-' + id);
  var pmlEl = document.getElementById('sc-r-pml-' + id);
  var totEl = document.getElementById('sc-r-tot-' + id);
  if (volEl) { volEl.textContent = c.ok ? c.volFinal.toFixed(3) + ' m³' : '—'; volEl.className = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (pmlEl) { pmlEl.innerHTML = c.priceAvailable ? scPricePairHtml(c.publicPuM3, c.puM3, c.customPricePending, true, ' / m³') : (c.ok ? 'Prix indisponible' : '—'); pmlEl.className = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (totEl) { totEl.innerHTML = c.priceAvailable ? scPricePairHtml(c.publicTotalHT, c.totalHT, c.customPricePending, false, '') : (c.ok ? 'Prix indisponible' : '—'); }
  scMajTotaux();
}

// ── Création ligne volige (longueur = select 2,5 / 3 / 4 m) ──
function scAddRowV(r, focus) {
  document.getElementById('sc-v-empty').style.display = 'none';
  var tbody = document.getElementById('sc-tbody-v');
  var tr = document.createElement('tr');
  tr.id = 'sc-row-v-' + r.id;
  tr.innerHTML =
    '<td><select id="sc-v-ep-' + r.id + '" onchange="scUpdV(' + r.id + ',\'ep\',this.value)" style="min-width:78px">'
    + '<option value="15"' + (String(r.ep) === '15' ? ' selected' : '') + '>15 mm</option>'
    + '<option value="18"' + (String(r.ep) === '18' ? ' selected' : '') + '>18 mm</option>'
    + '</select></td>'
    + '<td><input id="sc-v-la-' + r.id + '" type="number" min="1" step="1" placeholder="1"'
    + ' onchange="scUpdV(' + r.id + ',\'la\',this.value)"></td>'
    + '<td><select onchange="scUpdV(' + r.id + ',\'lo\',this.value)" style="min-width:80px">'
    + '<option value="">— m —</option>'
    + '<option value="2.5">2,5 m</option>'
    + '<option value="3">3,0 m</option>'
    + '<option value="4">4,0 m</option>'
    + '</select></td>'
    + '<td style="text-align:center"><input type="checkbox"'
    + ' onchange="scUpdV(' + r.id + ',\'traitement\',this.checked)"></td>'
    + '<td style="text-align:center"><input id="sc-v-mi-' + r.id + '" type="checkbox"'
    + ' onchange="scUpdV(' + r.id + ',\'miBois\',this.checked)"></td>'
    + '<td id="sc-v-m2-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-v-pu-' + r.id + '" class="sc-num sc-muted">—</td>'
    + '<td id="sc-v-tot-' + r.id + '" class="sc-num" style="font-weight:600">—</td>'
    + '<td><button type="button" class="sc-del" onclick="scDelV(' + r.id + ')">✕</button></td>';
  tbody.appendChild(tr);
  scUpdateRowV(r.id);
  if (focus !== false) scFocusFirstField(tr);
}

// ── Mise à jour cellules résultat volige ──────────────────────
function scUpdateRowV(id) {
  var r = scRowsV.find(function(x) { return x.id === id; });
  if (!r) return;
  var c = scCalcV(r);
  var epEl = document.getElementById('sc-v-ep-' + id);
  var laEl = document.getElementById('sc-v-la-' + id);
  var miEl = document.getElementById('sc-v-mi-' + id);
  if (epEl) epEl.value = String(r.ep);
  if (laEl && r.la !== '') laEl.value = String(r.la);
  if (miEl) {
    miEl.checked = !!r.miBois;
    miEl.disabled = String(r.ep) !== '18';
    miEl.title = miEl.disabled ? 'Le mi-bois est disponible uniquement en 18 mm.' : '';
  }
  var m2El  = document.getElementById('sc-v-m2-'  + id);
  var puEl  = document.getElementById('sc-v-pu-'  + id);
  var totEl = document.getElementById('sc-v-tot-' + id);
  if (m2El)  { m2El.textContent  = c.ok ? c.m2.toFixed(2)   + ' m²' : '—'; m2El.className  = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (puEl)  { puEl.innerHTML  = c.priceAvailable ? scPricePairHtml(c.publicPuM2, c.puM2, c.customPricePending, false, ' / m²') : (c.ok ? 'Prix indisponible' : '—'); puEl.className  = 'sc-num' + (c.ok ? '' : ' sc-muted'); }
  if (totEl) { totEl.innerHTML = c.priceAvailable ? scPricePairHtml(c.publicTotalHT, c.totalHT, c.customPricePending, false, '') : (c.ok ? 'Prix indisponible' : '—'); }
  scMajTotaux();
}

// ── État du récapitulatif, sans calcul tarifaire local ─────────
function scMajTotaux() {
  var t = scTotaux();
  var eligible = document.getElementById('sc-t-eligible');
  var rabote = document.getElementById('sc-t-rabote');
  var subtotal = document.getElementById('sc-t-st');
  var finalPrice = document.getElementById('sc-t-ttc');
  var mainCount = t.countC + t.countV;
  var orderableCount = mainCount + t.countR;
  var mainValue = t.mainPriceComplete ? scFmt(scDisplayedPrice(t.totalMain)) : (mainCount ? 'À confirmer' : '—');
  var raboteValue = t.rabotePriceComplete ? scFmt(scDisplayedPrice(t.totalR)) : (t.countR ? 'À confirmer' : '—');
  var totalValue = t.priceComplete ? scFmt(scDisplayedPrice(t.total)) : (orderableCount ? 'À confirmer' : '—');

  if (eligible) eligible.textContent = mainValue;
  if (rabote) rabote.textContent = raboteValue;
  if (subtotal) subtotal.textContent = totalValue;
  if (finalPrice) finalPrice.textContent = orderableCount ? 'À confirmer dans le panier' : '—';
}

// ── CRUD ───────────────────────────────────────────────────────
function scAddC(focus) {
  var sections = scCharpenteSections();
  var first = sections[0] || { ep: '', la: '' };
  var r = { id: scId++, ep: String(first.ep || ''), la: String(first.la || ''), lo: '', qt: '1', essence: 'Sapin/Épicéa', traitement: false, sechage: SC_SECHAGE_DEFAUT };
  var lengths = scCharpenteLengthsFor(r);
  if (lengths.length) r.lo = String(lengths[0]);
  scRowsC.push(r); scAddRowC(r, focus); scUpdateRowC(r.id); scSetEmptyHint('sc-c-empty', false); scMajTotaux(); scScheduleCustomPriceProbe();
}
function scDelC(id) {
  scRowsC = scRowsC.filter(function(r) { return r.id !== id; });
  var tr = document.getElementById('sc-row-c-' + id);
  if (tr) tr.parentNode.removeChild(tr);
  scSetEmptyHint('sc-c-empty', scRowsC.length === 0);
  scMajTotaux();
}
function scUpdC(id, f, v) {
  var r = scRowsC.find(function(r) { return r.id === id; });
  if (!r) return;
  if (f === 'sechage' && !SC_SECHAGE[v]) v = SC_SECHAGE_DEFAUT;
  var n = parseFloat(v);
  if (!isNaN(n) && v.toString().trim() !== '') {
    if (f === 'ep' || f === 'la') { v = String(scClamp(n, SC_EP_MIN, SC_EP_MAX)); }
    if (f === 'lo')               { v = String(scClamp(scRoundLengthUp(n), SC_LO_MIN, SC_LO_MAX)); }
    if (f === 'qt') {
      var quantityInput = document.getElementById('sc-c-qt-' + id);
      if (quantityInput) quantityInput.value = v;
    }
  }
  r[f] = v;
  scUpdateRowC(id);
  scScheduleCustomPriceProbe();
}
function scUpdCEss(id, v) {
  var r = scRowsC.find(function(r) { return r.id === id; });
  if (r) { r.essence = v; if (v === 'Douglas') r.traitement = false; scUpdateRowC(id); scScheduleCustomPriceProbe(); }
}

function scAddR(focus) {
  var sections = scRabotSections();
  var section = sections[0] || { ep: 45, la: 45 };
  var r = {
    id: scId++, ep: String(section.ep), la: String(section.la), lo: '2.5', qt: '1',
    essence: 'Sapin/Épicéa', traitement: false, sechage: SC_RABOT_SECHAGE_DEFAUT
  };
  var lengths = scRabotLengthsFor(r);
  if (lengths.length) r.lo = String(lengths[0]);
  scRowsR.push(r); scAddRowR(r, focus); scUpdateRowR(r.id); scSetEmptyHint('sc-r-empty', false); scMajTotaux(); scScheduleCustomPriceProbe();
}function scDelR(id) {
  scRowsR = scRowsR.filter(function(r) { return r.id !== id; });
  var tr = document.getElementById('sc-row-r-' + id);
  if (tr) tr.parentNode.removeChild(tr);
  scSetEmptyHint('sc-r-empty', scRowsR.length === 0);
  scMajTotaux();
}
function scUpdR(id, f, v) {
  var r = scRowsR.find(function(row) { return row.id === id; });
  if (!r) return;
  if (f === 'ep') {
    r.ep = String(parseInt(v, 10) || '');
    var widths = scRabotWidthsFor(r);
    if (widths.length && widths.indexOf(parseInt(r.la, 10)) === -1) r.la = String(widths[0]);
  } else if (f === 'la') {
    r.la = String(parseInt(v, 10) || '');
  } else if (f === 'lo') {
    var length = parseFloat(v);
    if (!isNaN(length)) r.lo = String(scClamp(scRoundLengthUp(length), SC_RABOT_LO_MIN, SC_RABOT_LO_MAX));
  } else if (f === 'qt') {
    var quantity = parseInt(v, 10);
    r.qt = String(quantity > 0 ? quantity : 1);
  } else if (f === 'sechage') {
    r.sechage = v === 'sechoir18' ? 'sechoir18' : 'naturel18';
  } else {
    r[f] = v;
  }
  scUpdateRowR(id);
  scScheduleCustomPriceProbe();
}function scUpdREss(id, v) {
  var r = scRowsR.find(function(r) { return r.id === id; });
  if (r) { r.essence = v; if (v === 'Douglas') r.traitement = false; scUpdateRowR(id); scScheduleCustomPriceProbe(); }
}

function scAddV(focus) {
  var r = { id: scId++, ep: '15', la: '', lo: '', traitement: false, miBois: false };
  scRowsV.push(r); scAddRowV(r, focus); scMajTotaux(); scScheduleCustomPriceProbe();
}
function scDelV(id) {
  scRowsV = scRowsV.filter(function(r) { return r.id !== id; });
  var tr = document.getElementById('sc-row-v-' + id);
  if (tr) tr.parentNode.removeChild(tr);
  document.getElementById('sc-v-empty').style.display = scRowsV.length ? 'none' : 'block';
  scMajTotaux();
}
function scUpdV(id, f, v) {
  var r = scRowsV.find(function(r) { return r.id === id; });
  if (!r) return;
  if (f === 'ep') {
    v = (v === '18') ? '18' : '15';
    if (v === '15') r.miBois = false;
  }
  if (f === 'miBois') {
    v = !!v && String(r.ep) === '18';
  }
  if (f === 'la') {
    var largeur = parseFloat(v);
    if (!isNaN(largeur) && largeur > 0) {
      v = String(Math.ceil(largeur - 1e-9));
    }
  }
  r[f] = v;
  scUpdateRowV(id);
  scScheduleCustomPriceProbe();
}

// ── Lecture formulaire ────────────────────────────────────────
var scQuoteFormVisible = false;

function scShowQuoteForm() {
  if (scQuoteFormVisible) return true;
  scQuoteFormVisible = true;
  document.querySelectorAll('.sc-quote-only').forEach(function(el) { el.classList.add('is-visible'); });
  var panel = document.getElementById('sc-quote-contact');
  if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  var button = document.getElementById('sc-request-quote');
  if (button) button.textContent = '✉  Envoyer la demande de devis';
  return true;
}
function scToggleDifferentDelivery(checked) {
  var block = document.getElementById('sc-delivery-alt');
  if (block) block.style.display = checked ? 'block' : 'none';
}
function scMajLivraisonChoisie() { return true; }

function scClient() {
  var choice = document.querySelector('input[name="sc-delivery-choice"]:checked');
  var lm = choice ? choice.value : 'pickup';
  var differentAddress = document.getElementById('sc-liv-different');
  var useDifferentAddress = !!(differentAddress && differentAddress.checked);
  function g(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  return {
    prenom      : g('sc-prenom'),
    nom         : g('sc-nom'),
    email       : g('sc-email'),
    phone       : g('sc-phone'),
    company     : g('sc-company'),
    projet      : g('sc-projet'),
    comment     : g('sc-commentaires'),
    factAdresse : g('sc-fact-adresse'),
    factCP      : g('sc-fact-cp'),
    factVille   : g('sc-fact-ville'),
    livraison   : lm,
    deliveryLabel: lm === 'pickup' ? 'Retrait au dépôt' : 'Livraison à l’adresse indiquée, tarif à calculer par Syleva',
    deliveryPrice: lm === 'pickup' ? 0 : null,
    livAdresse  : lm === 'pickup' || !useDifferentAddress ? g('sc-fact-adresse') : g('sc-liv-adresse'),
    livCP       : lm === 'pickup' || !useDifferentAddress ? g('sc-fact-cp') : g('sc-liv-cp'),
    livVille    : lm === 'pickup' || !useDifferentAddress ? g('sc-fact-ville') : g('sc-liv-ville')
  };
}

// ── Sécurité HTML et prix retournés par le panier ─────────────
function scEscHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function scCartMoney(cents) {
  return scFmt(scDisplayedPrice((Number(cents) || 0) / 100));
}
function scCartUnitPrice(item, type, properties) {
  var unitEuros = (Number(item.final_price != null ? item.final_price : item.price) || 0) / 100;
  if (type === 'charpente') {
    var epC = parseFloat(properties['_sc_ep']) || 0;
    var laC = parseFloat(properties['_sc_width']) || 0;
    var lengthC = parseFloat(properties['_sc_length']) || 0;
    var volumePieceC = (epC / 1000) * (laC / 1000) * lengthC;
    return volumePieceC > 0
      ? scFmtWhole(scDisplayedPrice(unitEuros / volumePieceC)) + ' / m³'
      : 'Prix indisponible';
  }
  if (type === 'volige') {
    var length = parseFloat(properties['_sc_length'] || properties['Longueur']) || 0;
    return length > 0
      ? scFmt(scDisplayedPrice(unitEuros / length)) + ' / m²'
      : 'Prix indisponible';
  }
  if (type === 'rabote') {
    var ep = parseFloat(properties['_sc_ep']) || 0;
    var la = parseFloat(properties['_sc_width']) || 0;
    var lengthR = parseFloat(properties['_sc_length']) || 0;
    var volumePiece = (ep / 1000) * (la / 1000) * lengthR;
    return volumePiece > 0
      ? scFmtWhole(scDisplayedPrice(unitEuros / volumePiece)) + ' / m³'
      : 'Prix indisponible';
  }
  return 'Bientôt disponible';
}
function scBuildHtmlFromCart(cartItems) {
  var cl = scClient();
  var nom = [cl.prenom, cl.nom].filter(Boolean).join(' ') || 'Client';
  var total = 0, eligible = 0, rabote = 0;
  var orderedItems = cartItems.slice().sort(function(a, b) {
    var ao = parseInt((a.properties || {})._sc_order, 10);
    var bo = parseInt((b.properties || {})._sc_order, 10);
    if (isNaN(ao) || isNaN(bo)) return 0;
    return ao - bo;
  });
  var rows = orderedItems.map(function(item) {
    var p = item.properties || {};
    var type = p._sc_type || '';
    var lineCents = item.final_line_price != null ? item.final_line_price : item.line_price;
    total += Number(lineCents) || 0;
    if (type === 'rabote') rabote += Number(lineCents) || 0;
    else eligible += Number(lineCents) || 0;
    var price = scCartUnitPrice(item, type, p);
    var linePrice = scCartMoney(lineCents);
    if (type === 'volige') {
      var voligeTreatment = p['_sc_treatment'] || p['Traitement'] || '';
      var voligeOption = p['_sc_option'] || (p['Mi-bois'] === 'Oui' ? 'Mi-bois' : 'Bords droits');
      var voligeInfo = [voligeTreatment, voligeOption, p['_sc_delay'] || p['Délai de fabrication'] || ''].filter(Boolean).join('<br>');
      return '<tr><td>Volige ' + scEscHtml(p['_sc_ep'] || p['Épaisseur']) + '</td>'
        + '<td>' + scEscHtml(p['_sc_width'] || p['Largeur']) + '</td>'
        + '<td style="text-align:center">' + scEscHtml(p['_sc_length'] || p['Longueur']) + '</td>'
        + '<td style="text-align:center">' + scEscHtml(item.quantity) + '</td>'
        + '<td>' + scEscHtml(p['_sc_essence'] || 'Sapin / Épicéa') + '</td>'
        + '<td>' + scEscHtml(voligeInfo).replace(/&lt;br&gt;/g, '<br>') + '</td>'
        + '<td class="num">' + scPdfPricePair(p['_sc_public_unit'], price) + '</td><td class="num">' + scPdfPricePair(p['_sc_public_total'], linePrice) + '</td></tr>';
    }
    if (type === 'rabote') {
      var raboteInfo = [p['_sc_treatment'] || '', p['_sc_sechage'] || '', p['_sc_delay'] || ''].filter(Boolean).join('<br>');
      return '<tr><td>Bois raboté</td>'
        + '<td>' + scEscHtml(p['_sc_section'] || '') + '</td>'
        + '<td style="text-align:center">' + scEscHtml(p['_sc_length'] || '') + '</td>'
        + '<td style="text-align:center">' + scEscHtml(p['_sc_requested_quantity'] || item.quantity) + '</td>'
        + '<td>' + scEscHtml(p['_sc_essence'] || '') + '</td>'
        + '<td>' + scEscHtml(raboteInfo).replace(/&lt;br&gt;/g, '<br>') + '</td>'
        + '<td class="num">' + scPdfPricePair(p['_sc_public_unit'], price) + '</td><td class="num">' + scPdfPricePair(p['_sc_public_total'], linePrice) + '</td></tr>';
    }
    var charpenteInfo = [p['_sc_treatment'] || '', p['_sc_sechage'] || '', p['_sc_delay'] || ''].filter(Boolean).join('<br>');
    return '<tr><td>Charpente</td>'
      + '<td>' + scEscHtml(p['_sc_section'] || p['Section demandée']) + '</td>'
      + '<td style="text-align:center">' + scEscHtml(p['_sc_length'] || p['Longueur demandée']) + '</td>'
      + '<td style="text-align:center">' + scEscHtml(p['_sc_requested_quantity'] || p['Quantité demandée'] || item.quantity) + '</td>'
      + '<td>' + scEscHtml(p['_sc_essence'] || '') + '</td>'
      + '<td>' + scEscHtml(charpenteInfo).replace(/&lt;br&gt;/g, '<br>') + '</td>'
      + '<td class="num">' + scPdfPricePair(p['_sc_public_unit'], price) + '</td><td class="num">' + scPdfPricePair(p['_sc_public_total'], linePrice) + '</td></tr>';
  }).join('');
  var livTxt = cl.deliveryLabel || (cl.livraison === 'pickup'
    ? 'Retrait au dépôt — Clermont centre'
    : 'Livraison à confirmer');
  if (cl.deliveryPrice != null && cl.livraison !== 'pickup') livTxt += ' : ' + scFmt(cl.deliveryPrice) + ' €';
  var companyHtml = cl.company ? '<br>Société : ' + scEscHtml(cl.company) : '';
  var factAddressHtml = scEscHtml(cl.factAdresse) + '<br>'
    + scEscHtml(cl.factCP) + ' ' + scEscHtml(cl.factVille);
  var livAddressHtml = cl.livraison === 'pickup'
    ? 'Clermont centre<br>Retrait au dépôt'
    : scEscHtml(cl.livAdresse) + '<br>' + scEscHtml(cl.livCP) + ' ' + scEscHtml(cl.livVille);
  return '<!doctype html><html><head><meta charset="utf-8"><title>Outil de chiffrage Syleva</title>'
    + '<style>body{font-family:Arial,sans-serif;color:#03191E;margin:28px;font-size:11px}h1{font-size:21px}h2{font-size:14px;border-bottom:1px solid #ddd;padding-bottom:5px;margin-top:24px}table{border-collapse:collapse;width:100%;margin-top:8px}th,td{border-bottom:1px solid #e5e5e5;padding:6px 5px;text-align:left}th{font-size:9px;text-transform:uppercase;color:#617074}.addresses{margin-top:8px}.addresses td{width:33.33%;vertical-align:top;border:1px solid #e5e5e5}.num{text-align:right;white-space:nowrap}.summary{margin:18px 0 0 auto;width:380px}.summary td{font-size:11px}.summary .strong td{font-weight:bold;border-top:2px solid #03191E}.notice{background:#f5f7f7;padding:10px;margin-top:18px}.small{color:#617074;font-size:9px}</style></head><body>'
    + '<h1>Outil de chiffrage Syleva</h1><p class="small">Date : ' + scEscHtml(scDate()) + '<br>Client : ' + scEscHtml(nom) + companyHtml + '<br>E-mail : ' + scEscHtml(cl.email) + '<br>Téléphone : ' + scEscHtml(cl.phone) + '<br>' + livTxt + '</p>'
    + '<h2>Coordonnées et adresses</h2><table class="addresses"><tbody><tr>'
    + '<td><strong>Client</strong><br>' + scEscHtml(nom) + companyHtml + '<br>' + scEscHtml(cl.email) + '<br>' + scEscHtml(cl.phone) + '</td>'
    + '<td><strong>Adresse de facturation</strong><br>' + factAddressHtml + '</td>'
    + '<td><strong>Adresse de livraison</strong><br>' + livAddressHtml + '</td>'
    + '</tr></tbody></table>'
    + (cl.comment ? '<h2>Commentaires ou spécifications à partager avec Syleva</h2><div class="notice">' + scEscHtml(cl.comment).replace(/\n/g, '<br>') + '</div>' : '')
    + '<h2>Détail des produits</h2><table><thead><tr><th>Produit</th><th>Format / largeur</th><th>Longueur</th><th>Qté</th><th>Essence</th><th>Traitement / séchage</th><th>Prix unitaire ' + scPriceModeLabel() + '</th><th>Total ligne ' + scPriceModeLabel() + '</th></tr></thead><tbody>' + rows + '</tbody></table>'
    + '<table class="summary"><tbody><tr><td>Charpente + Volige</td><td class="num">' + scCartMoney(eligible) + '</td></tr>'
    + '<tr><td>Bois raboté</td><td class="num">' + scCartMoney(rabote) + '</td></tr>'
    + '<tr class="strong"><td>Total des lignes</td><td class="num">' + scCartMoney(total) + '</td></tr></tbody></table>'
    + '<div class="notice">Les tarifs indiqués dans le présent document sont estimatifs et non contractuels. Affichage ' + scPriceModeLabel() + '. Les frais de livraison ne sont pas inclus.</div>'
    + '<div class="notice"><strong>' + scEscHtml(SC_CUSTOM_ORDER_WARNING) + '</strong></div>'
    + '</body></html>';
}

// ── Voir l'estimatif ──────────────────────────────────────────
function scVoirDevis() {
  var win = window.open('', '_blank');
  if (!win) { alert('Veuillez autoriser les pop-ups pour afficher l\'estimatif.'); return; }
  var token = scCartToken();
  var items;
  try {
    items = scBuildCartItems(token);
  } catch (error) {
    win.close();
    scShowCartStatus(error.message, true);
    return;
  }
  scShowCartStatus('Préparation de l\'estimatif depuis le panier…', false);
  scPostCartItems(items)
    .then(function() { return scGetCart(); })
    .then(function(cart) {
      var added = cart.items.filter(function(item) {
        return item.properties && item.properties._sc_token === token;
      });
      if (!added.length) throw new Error('Les lignes ajoutées n\'ont pas pu être retrouvées dans le panier.');
      win.document.write(scBuildHtmlFromCart(added));
      win.document.close();
      scShowCartStatus('', false);
      setTimeout(function() { win.print(); }, 900);
    })
    .catch(function(error) {
      win.close();
      scShowCartStatus(error.message || 'Impossible de générer l\'estimatif depuis le panier.', true);
    });
}

// ── Demande de devis vers Google Apps Script ───────────────────
var SC_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby6U15LRx4H5Jon85M5_4F6973Db4Sxwps39zRtG1z9yu503etu5uEPKE7Kx_tfrB9o/exec';
var scQuoteSending = false;

function scQuoteValidation() {
  if (!scQuoteFormVisible) { scShowQuoteForm(); return false; }
  var rgpd = document.getElementById('sc-rgpd');
  if (!rgpd || !rgpd.checked) {
    alert('Merci de cocher la case de consentement avant d\'envoyer votre demande.');
    return false;
  }
  var cl = scClient();
  if (!cl.prenom || !cl.nom) { alert('Merci de renseigner votre prénom et votre nom.'); return false; }
  if (!cl.email) { alert('Merci de renseigner votre adresse email.'); return false; }
  if (!cl.phone) { alert('Merci de renseigner votre numéro de téléphone.'); return false; }
  if (!cl.factAdresse || !cl.factCP || !cl.factVille) { alert('Merci de compléter votre adresse de facturation.'); return false; }
  var differentAddress = document.getElementById('sc-liv-different');
  if (cl.livraison !== 'pickup' && differentAddress && differentAddress.checked && (!cl.livAdresse || !cl.livCP || !cl.livVille)) {
    alert('Merci de renseigner l’adresse de livraison différente.');
    return false;
  }
  var totals = scTotaux();
  if (!totals.hasOrderableItems) { alert('Ajoute au moins une ligne valide de charpente ou de volige.'); return false; }
  return true;
}

function scRemoveCartItems(items) {
  if (!items || !items.length) return Promise.resolve();
  return items.reduce(function(promise, item) {
    return promise.then(function() {
      if (!item.key) return null;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).then(function(response) {
        if (!response.ok) throw new Error('Impossible de nettoyer le panier après l’envoi du devis.');
        return response;
      });
    });
  }, Promise.resolve());
}

function scSendQuoteToAppsScript(payload) {
  return new Promise(function(resolve, reject) {
    var frameName = 'sc-quote-frame-' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = frameName;
    iframe.src = 'about:blank';
    iframe.style.display = 'none';

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = SC_APPS_SCRIPT_URL;
    form.target = frameName;
    form.style.display = 'none';

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'payload';
    input.value = JSON.stringify(payload);
    form.appendChild(input);

    var finished = false;
    var submittedAt = 0;

    function cleanup() {
      if (finished) return;
      finished = true;
      window.removeEventListener('message', onMessage);
      if (form.parentNode) form.parentNode.removeChild(form);
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }

    function succeed(result) {
      if (finished) return;
      cleanup();
      resolve(result || { success: true });
    }

    function onMessage(event) {
      var data = event.data || {};
      if (event.source !== iframe.contentWindow || data.type !== 'syleva_quote_result') return;
      var result = data.result || {};
      if (result.success) succeed(result);
      else {
        cleanup();
        reject(new Error(result.error || 'Apps Script n’a pas pu traiter la demande.'));
      }
    }

    // L’événement load de la réponse Apps Script sert de secours au
    // postMessage. Le premier chargement concerne uniquement about:blank.
    iframe.onload = function() {
      if (!submittedAt) return;
      // Éviter de prendre un éventuel chargement initial tardif pour la réponse.
      if (Date.now() - submittedAt < 1000) return;
      succeed({ success: true });
    };

    window.addEventListener('message', onMessage);
    document.body.appendChild(iframe);
    document.body.appendChild(form);

    // Ne pas attendre l’événement load initial de l’iframe : selon le navigateur,
    // cet événement peut ne pas être émis pour about:blank.
    setTimeout(function() {
      if (finished) return;
      submittedAt = Date.now();
      form.submit();
    }, 150);

    setTimeout(function() {
      if (!finished) {
        cleanup();
        reject(new Error('Le service de devis n’a pas répondu dans le délai prévu.'));
      }
    }, 180000);
  });
}

function scEnvoyerDevis() {
  if (scQuoteSending || !scQuoteValidation()) return;
  scQuoteSending = true;

  var button = document.querySelector('button[onclick="scEnvoyerDevis()"]');
  if (button) { button.disabled = true; button.textContent = 'Envoi de la demande…'; }
  scShowCartStatus('Préparation du document et des prix…', false);

  var token = scCartToken();
  var items;
  try {
    items = scBuildCartItems(token);
  } catch (error) {
    scQuoteSending = false;
    scShowCartStatus(error.message, true);
    if (button) { button.disabled = false; button.textContent = '✉  Envoyer une demande de devis à SYLEVA'; }
    return;
  }

  var cl = scClient();
  var nom = [cl.prenom, cl.nom].filter(Boolean).join(' ');
  var payload;

  scPostCartItems(items)
    .then(function() { return scGetCart(); })
    .then(function(cart) {
      var added = cart.items.filter(function(item) {
        return item.properties && item.properties._sc_token === token;
      });
      if (!added.length) throw new Error('Les lignes ajoutées n’ont pas pu être retrouvées dans le panier.');
      payload = {
        requestId: token,
        html: scBuildHtmlFromCart(added),
        clientName: nom,
        company: cl.company,
        clientEmail: cl.email,
        clientPhone: cl.phone,
        factAdresse: cl.factAdresse,
        factCP: cl.factCP,
        factVille: cl.factVille,
        livraison: cl.livraison,
        deliveryLabel: cl.deliveryLabel,
        deliveryPrice: cl.deliveryPrice,
        livAdresse: cl.livAdresse,
        livCP: cl.livCP,
        livVille: cl.livVille,
        priceMode: scPriceMode,
        subject: 'Demande de devis charpente – ' + nom + (cl.projet ? ' – ' + cl.projet : '')
      };
      scShowCartStatus('Envoi de la demande à SYLEVA…', false);
      return scSendQuoteToAppsScript(payload).then(function(result) {
        return scRemoveCartItems(added).then(function() { return result; });
      });
    })
    .then(function() {
      scShowCartStatus('Demande envoyée avec succès.', false);
      var success = document.getElementById('sc-success');
      var inner = document.getElementById('sc-form-inner');
      if (success) success.classList.add('visible');
      if (inner) inner.style.display = 'none';
    })
    .catch(function(error) {
      scShowCartStatus(error.message || 'Une erreur est survenue lors de l’envoi de la demande.', true);
      if (button) { button.disabled = false; button.textContent = '✉  Envoyer une demande de devis à SYLEVA'; }
    })
    .then(function() {
      scQuoteSending = false;
    });
}

// ── Ajout au panier Shopify ───────────────────────────────────
function scShowCartStatus(message, isError) {
  var el = document.getElementById('sc-cart-status');
  if (!el) return;
  if (!message) {
    el.style.display = 'none';
    el.textContent = '';
    return;
  }
  el.style.display = 'block';
  el.style.color = isError ? '#a12622' : '#176b43';
  el.textContent = message;
}

function scParseCharpenteSku(sku) {
  var match = String(sku || '').match(/^SCH(\d{3})(\d{3})(\d{2})P([CS])([AS]?)(J?)$/);
  if (!match) return null;
  var ep = parseInt(match[1], 10);
  var la = parseInt(match[2], 10);
  // Garde-fou : une volige (15 ou 18 mm) ne doit jamais être interprétée
  // comme une section de charpente, même si son SKU commence également par SCH.
  if (ep < SC_EP_MIN || la < SC_EP_MIN) return null;
  return {
    ep: ep,
    la: la,
    longueurDm: parseInt(match[3], 10),
    essence: match[4] === 'S' ? 'Douglas' : 'Sapin/Épicéa',
    sechage: match[5] === 'S' ? 'sechoir18' : (match[5] === 'A' ? 'naturel18' : 'standard'),
    traitement: match[6] === 'J'
  };
}

function scCharpenteVariants() {
  var variants = [];
  ['epicea', 'douglas'].forEach(function(key) {
    var source = window.SC_SHOPIFY && window.SC_SHOPIFY[key];
    if (source && Array.isArray(source.variants)) variants = variants.concat(source.variants);
  });
  return variants;
}
function scCharpenteSections() {
  var sections = [];
  scCharpenteVariants().forEach(function(v) {
    var d = scParseCharpenteSku(v.sku);
    if (!d) return;
    if (!sections.some(function(s) { return s.ep === d.ep && s.la === d.la; })) {
      sections.push({ ep: d.ep, la: d.la });
    }
  });
  return sections.sort(function(a, b) { return a.ep - b.ep || a.la - b.la; });
}
function scCharpenteThicknesses() {
  var values = [];
  scCharpenteSections().forEach(function(section) {
    if (values.indexOf(section.ep) === -1) values.push(section.ep);
  });
  return values.sort(function(a, b) { return a - b; });
}
function scCharpenteWidthsFor(r) {
  var widths = [];
  scCharpenteSections().forEach(function(section) {
    if (section.ep === parseInt(r.ep, 10) && widths.indexOf(section.la) === -1) widths.push(section.la);
  });
  return widths.sort(function(a, b) { return a - b; });
}
function scCharpenteLengthsFor(r) {
  var wanted = scCharpenteVariants().filter(function(v) {
    var d = scParseCharpenteSku(v.sku);
    return d && d.ep === parseInt(r.ep, 10) && d.la === parseInt(r.la, 10)
      && d.essence === r.essence && d.sechage === r.sechage
      && d.traitement === (!!r.traitement && r.essence === 'Sapin/Épicéa');
  });
  if (!wanted.length) {
    wanted = scCharpenteVariants().filter(function(v) {
      var d = scParseCharpenteSku(v.sku);
      return d && d.ep === parseInt(r.ep, 10) && d.la === parseInt(r.la, 10);
    });
  }
  var lengths = [];
  wanted.forEach(function(v) {
    var d = scParseCharpenteSku(v.sku);
    var length = d.longueurDm / 10;
    if (lengths.indexOf(length) === -1) lengths.push(length);
  });
  return lengths.sort(function(a, b) { return a - b; });
}
function scCharpenteThicknessOptions(selected) {
  return scCharpenteThicknesses().map(function(value) {
    return '<option value="' + value + '"' + (String(value) === String(selected) ? ' selected' : '') + '>'
      + value + ' mm</option>';
  }).join('');
}
function scCharpenteWidthOptions(r) {
  return scCharpenteWidthsFor(r).map(function(value) {
    return '<option value="' + value + '"' + (String(value) === String(r.la) ? ' selected' : '') + '>'
      + value + ' mm</option>';
  }).join('');
}
function scCharpenteLengthOptions(r) {
  var lengths = scCharpenteLengthsFor(r);
  if (!lengths.length) return '<option value="">— m —</option>';
  return lengths.map(function(value) {
    var label = String(value).replace('.', ',');
    return '<option value="' + value + '"' + (String(value) === String(r.lo) ? ' selected' : '') + '>'
      + label + ' m</option>';
  }).join('');
}
function scRefreshCWidths(id) {
  var r = scRowsC.find(function(x) { return x.id === id; });
  var select = document.getElementById('sc-c-la-' + id);
  if (!r || !select) return;
  var widths = scCharpenteWidthsFor(r);
  if (!widths.length) {
    select.innerHTML = '<option value="">— mm —</option>';
    r.la = '';
    return;
  }
  var current = parseInt(r.la, 10);
  if (isNaN(current) || widths.indexOf(current) === -1) r.la = String(widths[0]);
  select.innerHTML = scCharpenteWidthOptions(r);
  select.value = String(r.la);
}
function scRefreshCLengths(id) {
  var r = scRowsC.find(function(x) { return x.id === id; });
  var select = document.getElementById('sc-c-lo-' + id);
  if (!r || !select) return;
  var lengths = scCharpenteLengthsFor(r);
  if (!lengths.length) {
    select.innerHTML = '<option value="">— m —</option>';
    r.lo = '';
    return;
  }
  var current = parseFloat(r.lo);
  if (isNaN(current) || lengths.indexOf(current) === -1) r.lo = String(lengths[0]);
  select.innerHTML = scCharpenteLengthOptions(r);
  select.value = String(r.lo);
}

function scFindCharpenteVariant(r) {
  var source = r.essence === 'Douglas'
    ? (window.SC_SHOPIFY && window.SC_SHOPIFY.douglas)
    : (window.SC_SHOPIFY && window.SC_SHOPIFY.epicea);
  if (!source || !Array.isArray(source.variants)) return null;
  var lengthDm = Math.round((parseFloat(r.lo) || 0) * 10);
  for (var i = 0; i < source.variants.length; i++) {
    var v = source.variants[i];
    var d = scParseCharpenteSku(v.sku);
    if (!d) continue;
    if (d.ep === parseInt(r.ep, 10) && d.la === parseInt(r.la, 10)
      && d.longueurDm === lengthDm && d.sechage === r.sechage
      && d.traitement === (!!r.traitement && r.essence === 'Sapin/Épicéa')) return v;
  }
  return null;
}

function scRabotVariants() {
  var variants = window.SC_SHOPIFY && window.SC_SHOPIFY.rabote
    ? window.SC_SHOPIFY.rabote.variants : [];
  return Array.isArray(variants) ? variants : [];
}
function scParseRabotSku(sku) {
  var match = String(sku || '').match(/^SOS(\d{3})(\d{3})(\d{2})P([CS])R([AS])(J?)$/);
  if (!match) return null;
  return {
    ep: parseInt(match[1], 10),
    la: parseInt(match[2], 10),
    longueurDm: parseInt(match[3], 10),
    essence: match[4] === 'S' ? 'Douglas' : 'Sapin/Épicéa',
    sechage: match[5] === 'S' ? 'sechoir18' : 'naturel18',
    traitement: match[6] === 'J'
  };
}
function scRabotSections() {
  var sections = [];
  scRabotVariants().forEach(function(v) {
    var decoded = scParseRabotSku(v.sku);
    if (!decoded) return;
    var exists = sections.some(function(s) { return s.ep === decoded.ep && s.la === decoded.la; });
    if (!exists) sections.push({ ep: decoded.ep, la: decoded.la });
  });
  return sections.sort(function(a, b) { return a.ep - b.ep || a.la - b.la; });
}
function scRabotLengthsFor(r) {
  var wanted = scRabotVariants().filter(function(v) {
    var d = scParseRabotSku(v.sku);
    return d && d.ep === parseInt(r.ep, 10) && d.la === parseInt(r.la, 10)
      && d.essence === r.essence
      && d.sechage === r.sechage
      && d.traitement === !!r.traitement;
  });
  if (!wanted.length) {
    wanted = scRabotVariants().filter(function(v) {
      var d = scParseRabotSku(v.sku);
      return d && d.ep === parseInt(r.ep, 10) && d.la === parseInt(r.la, 10);
    });
  }
  var lengths = [];
  wanted.forEach(function(v) {
    var d = scParseRabotSku(v.sku);
    var length = d.longueurDm / 10;
    if (lengths.indexOf(length) === -1) lengths.push(length);
  });
  return lengths.sort(function(a, b) { return a - b; });
}
function scFindRabotVariant(r) {
  var lengthDm = Math.round((parseFloat(r.lo) || 0) * 10);
  var variants = scRabotVariants();
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var decoded = scParseRabotSku(v.sku);
    if (!decoded) continue;
    if (decoded.ep === parseInt(r.ep, 10)
      && decoded.la === parseInt(r.la, 10)
      && decoded.longueurDm === lengthDm
      && decoded.essence === r.essence
      && decoded.sechage === r.sechage
      && decoded.traitement === !!r.traitement) return v;
  }
  return null;
}

function scParseVoligeSku(sku) {
  var match = String(sku || '').match(/^SCH(\d{3})(\d{4})(\d{2})PC([A-Z]*)$/);
  if (!match) return null;
  var flags = match[4];
  return {
    ep: parseInt(match[1], 10),
    largeurMm: parseInt(match[2], 10),
    longueurDm: parseInt(match[3], 10),
    traitement: flags.indexOf('J') !== -1,
    miBois: flags.indexOf('B') !== -1
  };
}

function scFindVoligeVariant(r) {
  var source = window.SC_SHOPIFY.volige;
  if (!source || !source.variants) return null;
  var lengthDm = Math.round((parseFloat(r.lo) || 0) * 10);
  for (var i = 0; i < source.variants.length; i++) {
    var v = source.variants[i];
    var decoded = scParseVoligeSku(v.sku);
    if (!decoded) continue;
    if (decoded.ep === parseInt(r.ep, 10)
      && decoded.largeurMm === 1000
      && decoded.longueurDm === lengthDm
      && decoded.traitement === !!r.traitement
      && decoded.miBois === !!r.miBois) return v;
  }
  return null;
}

function scFrenchNumber(value, decimals) {
  return Number(value).toFixed(decimals).replace('.', ',');
}

function scCartPropertiesCharpente(r, c, v, quantity, token, order) {
  var delay = v.backorderMessage || '';
  var delayField = delay || 'Fabrication à la commande';
  return {
    '_sc_type': 'charpente',
    '_sc_token': token,
    '_sc_order': String(order),
    '_sc_section': r.ep + ' × ' + r.la + ' mm',
    '_sc_ep': r.ep + ' mm',
    '_sc_width': r.la + ' mm',
    '_sc_length': r.lo + ' m',
    '_sc_requested_quantity': String(r.qt),
    '_sc_volume': scFrenchNumber(c.volTotalArrondi, 3) + ' m³',
    '_sc_public_unit': c.publicPuM3 != null ? scFmtWhole(scDisplayedPrice(c.publicPuM3)) + ' / m³' : '',
    '_sc_public_total': c.publicTotalHT != null ? scFmt(scDisplayedPrice(c.publicTotalHT)) + ' €' : '',
    '_sc_essence': r.essence,
    '_sc_treatment': r.traitement && r.essence === 'Sapin/Épicéa' ? 'Traitement jaune certifié' : 'Sans traitement',
    '_sc_sechage': scSechagePdfLabel(r.sechage),
    '_sc_delay': delayField,
    'Détail': delayField
  };
}

function scCartPropertiesRabot(r, c, v, quantity, token, order) {
  var delay = v.backorderMessage || '';
  var delayField = delay || 'Fabrication à la commande';
  return {
    '_sc_type': 'rabote',
    '_sc_token': token,
    '_sc_order': String(order),
    '_sc_section': r.ep + ' × ' + r.la + ' mm',
    '_sc_ep': r.ep + ' mm',
    '_sc_width': r.la + ' mm',
    '_sc_length': r.lo + ' m',
    '_sc_requested_quantity': String(r.qt),
    '_sc_volume': scFrenchNumber(c.volFinal, 3) + ' m³',
    '_sc_public_unit': c.publicPuM3 != null ? scFmtWhole(scDisplayedPrice(c.publicPuM3)) + ' / m³' : '',
    '_sc_public_total': c.publicTotalHT != null ? scFmt(scDisplayedPrice(c.publicTotalHT)) + ' €' : '',
    '_sc_essence': r.essence,
    '_sc_treatment': r.traitement && r.essence === 'Sapin/Épicéa' ? 'Traitement jaune certifié' : 'Sans traitement',
    '_sc_sechage': scSechagePdfLabel(r.sechage),
    '_sc_delay': delayField,
    'Détail': delayField
  };
}

function scCartPropertiesVolige(r, c, v, quantity, token, order) {
  var delay = v.backorderMessage || '';
  var delayField = delay || 'Fabrication à la commande';
  // Les informations produit/variante sont déjà affichées par Shopify.
  // Les champs internes servent uniquement à l'ordre et à la génération du PDF.
  return {
    '_sc_type': 'volige',
    '_sc_token': token,
    '_sc_order': String(order),
    '_sc_ep': r.ep + ' mm',
    '_sc_width': c.la + ' m',
    '_sc_length': r.lo + ' m',
    '_sc_public_unit': c.publicPuM2 != null ? scFmt(scDisplayedPrice(c.publicPuM2)) + ' / m²' : '',
    '_sc_public_total': c.publicTotalHT != null ? scFmt(scDisplayedPrice(c.publicTotalHT)) + ' €' : '',
    '_sc_essence': 'Sapin / Épicéa',
    '_sc_option': c.miBois ? 'Mi-bois' : 'Bords droits',
    '_sc_treatment': r.traitement ? 'Oui, jaune certifié' : 'Non',
    '_sc_delay': delayField,
    'Détail': delayField
  };
}

function scBuildCartItems(token) {
  if (!window.SC_SHOPIFY || !window.SC_SHOPIFY.epicea || !window.SC_SHOPIFY.douglas || !window.SC_SHOPIFY.volige || !window.SC_SHOPIFY.rabote) {
    throw new Error('La configuration des produits est introuvable.');
  }
  var items = [];
  var order = 0;
  var rowsC = scRowsC.filter(function(r) { return scCalcC(r).ok; });
  var rowsR = scRowsR.filter(function(r) { return scCalcR(r).ok; });
  var rowsV = scRowsV.filter(function(r) { return scCalcV(r).ok; });
  rowsC.forEach(function(r) {
    var c = scCalcC(r);
    var v = scFindCharpenteVariant(r);
    if (!v) throw new Error('Aucune variante ne correspond à la charpente ' + r.essence + ', traitement et séchage sélectionnés.');
    var quantity = c.quantity || (parseInt(r.qt, 10) || 1);
    if (quantity < 1) quantity = 1;
    items.push({ id: Number(v.id), quantity: quantity, properties: scCartPropertiesCharpente(r, c, v, quantity, token, order++) });
  });
  rowsR.forEach(function(r) {
    var c = scCalcR(r);
    var v = scFindRabotVariant(r);
    if (!v) throw new Error('Aucune variante ne correspond au bois raboté sélectionné.');
    var quantity = parseInt(r.qt, 10) || 1;
    items.push({ id: Number(v.id), quantity: quantity, properties: scCartPropertiesRabot(r, c, v, quantity, token, order++) });
  });
  rowsV.forEach(function(r) {
    var c = scCalcV(r);
    var v = scFindVoligeVariant(r);
    if (!v) throw new Error('Aucune variante ne correspond à la volige sélectionnée.');
    var quantity = c.quantity || Math.ceil(c.la - 1e-9);
    if (quantity < 1) quantity = 1;
    items.push({ id: Number(v.id), quantity: quantity, properties: scCartPropertiesVolige(r, c, v, quantity, token, order++) });
  });
  if (!items.length) throw new Error('Ajoute au moins une ligne valide de charpente ou de volige.');
  return items;
}

function scCartToken() {
  return 'sc-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
}
function scPostCartItems(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function(response) {
    return response.json().then(function(data) {
      if (!response.ok) throw new Error(data.description || data.message || 'La sélection n’a pas pu être ajoutée au panier.');
      return data;
    });
  });
}
function scGetCart() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(response) {
    if (!response.ok) throw new Error('Impossible de récupérer le panier.');
    return response.json();
  });
}
function scSetCartNote(comment) {
  if (!comment) return Promise.resolve();
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ note: comment })
  }).then(function(response) {
    if (!response.ok) throw new Error('Impossible d’enregistrer le commentaire dans le panier.');
    return response.json();
  });
}

function scAjouterPanier() {
  var button = document.getElementById('sc-add-cart');
  if (button) { button.disabled = true; button.textContent = 'Ajout au panier…'; }
  scShowCartStatus('Préparation de la commande…', false);
  var token = scCartToken();
  var items;
  try {
    items = scBuildCartItems(token);
  } catch (error) {
    scShowCartStatus(error.message, true);
    if (button) { button.disabled = false; button.textContent = '🛒  Ajouter la sélection au panier'; }
    return;
  }
  if (!window.confirm(SC_CUSTOM_ORDER_WARNING)) {
    scShowCartStatus('Ajout au panier annulé.', false);
    if (button) { button.disabled = false; button.textContent = '🛒  Ajouter la sélection au panier'; }
    return;
  }
  var client = scClient();
  scPostCartItems(items)
    .then(function() { return scSetCartNote(client.comment); })
    .then(function() {
      scShowCartStatus('Sélection ajoutée au panier. Redirection en cours…', false);
      window.location.href = '/cart';
    })
    .catch(function(error) {
      scShowCartStatus(error.message || 'Une erreur est survenue lors de l’ajout au panier.', true);
      if (button) { button.disabled = false; button.textContent = '🛒  Ajouter la sélection au panier'; }
    });
}

// ── Fonctions utilisées par les handlers inline du Liquid ─────
window.scToggleAccordion = scToggleAccordion;
window.scAddC = scAddC;
window.scDelC = scDelC;
window.scUpdC = scUpdC;
window.scUpdCEss = scUpdCEss;
window.scAddR = scAddR;
window.scDelR = scDelR;
window.scUpdR = scUpdR;
window.scUpdREss = scUpdREss;
window.scAddV = scAddV;
window.scDelV = scDelV;
window.scUpdV = scUpdV;
window.scAjouterPanier = scAjouterPanier;
window.scVoirDevis = scVoirDevis;
window.scEnvoyerDevis = scEnvoyerDevis;
window.scSetPriceMode = scSetPriceMode;
window.scMajLivraisonChoisie = scMajLivraisonChoisie;
window.scToggleDifferentDelivery = scToggleDifferentDelivery;

// ── Init ──────────────────────────────────────────────────────
var scInitialized = false;
function scInit() {
  if (scInitialized) return;
  scInitialized = true;
  // Le bouton TTC est actif dans le Liquid, on synchronise aussi l'état JS.
  scSetPriceMode('TTC');
  if (!scRowsC.length) scAddC(false);
  scScheduleCustomPriceProbe();
  scSetEmptyHint('sc-c-empty', scRowsC.length === 0);
  scSetEmptyHint('sc-r-empty', scRowsR.length === 0);
  scSetEmptyHint('sc-v-empty', scRowsV.length === 0);

  var form = document.getElementById('sc-form');
  if (form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scInit);
} else {
  scInit();
}
